module.exports = __webpack_public_path__ + "img/HTCC-MPU9250.1a624a32.jpg";